export default __webpack_public_path__ + "static/media/hero-image.581597dd.png";